import { Skeleton } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import PsContext from "../../context";
import { listAllCoursesV2 } from "../../models/courses";
import {
  COURSE_TYPE_SORT_ORDER,
  customSorting,
  groupByMultiple,
  MuiModalWindow,
  NoData,
  upperCase,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import AttendanceReportDetailsView from "./attendanceReportDetailsView";

const AttendanceReportDetails = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const [courses, setCourses] = useState([]);
  const [courseView, setCourseView] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState([]);

  useEffect(() => {
    listAllCoursesV2(1).then((res) => {
      if (res) {
        res = customSorting(res, COURSE_TYPE_SORT_ORDER, "academic_dept_type");
        let m = groupByMultiple(res, function (obj) {
          return [obj.academic_dept_type, obj.dept_type];
        });

        setCourses(res);
        setCourseView(m);
      }
    });
    getReport();
  }, []);

  const getReport = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.MOB.DASHBOARD_DAY_WISE_ATTENDANCE_REPORT)
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          let m = groupByMultiple(res["data"].data, function (obj) {
            return [obj.course];
          });

          setDataView(m);
        }
        setLoader(false);
      });
  };

  const handleItemClick = (items) => {
    setViewData(items);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setViewData([]);
    setShowModal(false);
  };

  const modalTitle = () => {
    if (viewData && viewData.length > 0) {
      let item = viewData[0];
      return `${upperCase(item.academic_dept_type)}`;
    }
  };
  return (
    <>
      <Header
        title="Attendace Report"
        rightActions={[]}
        backAction={true}
      ></Header>

      <div className="">
        <div className="container-sm py-md-3">
          {!loader && dataList.length < 1 && (
            <Card>
              <Card.Body>
                <div className="py-5">
                  <NoData />
                </div>
              </Card.Body>
            </Card>
          )}
          {dataList.length < 1 && loader && (
            <div className="p-4 bg-white">
              <Skeleton.Paragraph lineCount={5} animated />
            </div>
          )}
          {dataList.length > 0 && (
            <ul className="page-nav ps-0" style={{ padding: "0 10px" }}>
              {courseView.map((items, i) => {
                let item = items[0];
                return (
                  <li onClick={(e) => handleItemClick(items)}>
                    <a>
                      {upperCase(item.academic_dept_type)}
                      <i className="fa-solid fa-caret-right"></i>
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>

      <MuiModalWindow
        open={showModal}
        onClose={(e) => setShowModal(false)}
        title="Attendance Report"
      >
        <AttendanceReportDetailsView dataSource={viewData} attData={dataList} />
      </MuiModalWindow>
    </>
  );
};
export default AttendanceReportDetails;
